import { render } from "./Item4.vue?vue&type=template&id=7650f08e"
import script from "./Item4.vue?vue&type=script&lang=ts"
export * from "./Item4.vue?vue&type=script&lang=ts"
script.render = render

export default script